import "./App.css";
import Home from "./component/Home";

function App() {
  return (
    <div className="bg-black overflow-hidden">
      <Home />
    </div>
  );
}

export default App;
